import React from "react";
import StateMessage from "../components/StateMessage";

/** Unknown hash route: say so instead of rendering an empty page. */
export default function NotFoundPage() {
  return (
    <div className="not-found-page">
      <StateMessage title="Página no encontrada" linkTo="/" linkLabel="Ir al inicio">
        Este enlace no corresponde a ninguna página. Revisa la dirección o vuelve al inicio.
      </StateMessage>
    </div>
  );
}
